import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'clsx';
import { FormattedMessagePropType } from '../../prop-types/intl';
import { PackageMenuItem } from './package-menu-item';

import style from './package-dropdown.module.css';

export const PackageGroup = ({ groupName, packages, onChange, selectedPackageKey, itemClassName = '', groupClassName = '' }) => {
  return (
    <div key={groupName} className={style['dropdown-menu-section']}>
      <div className={classnames(style['dropdown-section-title'], groupClassName)}>{groupName}</div>
      {packages.map(({ packageId, name }) => (
        <PackageMenuItem
          key={packageId}
          itemClassName={itemClassName}
          name={name}
          onChange={onChange}
          packageId={packageId}
          selectedPackageKey={selectedPackageKey}
        />
      ))}
    </div>
  );
};

PackageGroup.propTypes = {
  groupName: PropTypes.oneOfType([PropTypes.string, FormattedMessagePropType]).isRequired,
  packages: PropTypes.arrayOf(
    PropTypes.shape({
      packageId: PropTypes.string,
      name: PropTypes.string,
    }),
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  selectedPackageKey: PropTypes.string,
  itemClassName: PropTypes.string,
  groupClassName: PropTypes.string,
};
